module.exports = __webpack_public_path__ + "img/img-main-bg07M.0666a331.png";